import React, { useEffect, useState } from "react";
import { Tree, Card, Row, Col, Divider, Empty, Modal, notification } from "antd";
import _ from "lodash";

/**
 * Actions
 */
import { allFormsOfSavedObjectsWithFields } from "auth/actions/objActions";
import { filterTree, renderTreeNodes } from "./utils.js";
import { ExclamationCircleOutlined, LockOutlined } from "@ant-design/icons";

export default function TreeTransfer(props) {
  const [clean, setClean] = useState([]);
  const [data, setData] = useState([]);
  const [checkedNodes, setCheckedNodes] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);

  useEffect(() => {
    onGet();
  }, [props.refresh, props.selected, props.needUpdated]);

  const onGet = () => {
    /**
     * Todos os campos com formName
     */
    allFormsOfSavedObjectsWithFields().then((items) => {
      const { removeSelected, formName } = props;
      const allResults = removeSelected ? items.message.filter(v => v.name !== formName) : items.message || [];
      setClean(allResults);
      // organiza os campos
      var filtered = allResults
        .map((obj) => ({
          title: obj.name.replace("obj_", ""),
          key: obj.name,
          children: obj.fields
            .filter((field) => field.fieldtype !== "label")
            .map((field) => {
            const isBlocked = props.blockedFields?.includes(field.field.trim().toUpperCase());
            return {
              key: field._id,
              title: (
                <span
                  style={{
                    opacity: isBlocked 
                    ? 0.4 
                    : 1, 
                    cursor: isBlocked 
                    ? "not-allowed" 
                    : "pointer"
                  }}
                >
                  {field.field}{isBlocked && <LockOutlined style={{ marginLeft: 6, color: '#e42121' }} />}
                </span>
              ),
              field: field.field,
              isBlocked
            }
          })
        }))
        .filter((obj) => _.size(obj.children) > 0);
      // carrega os campos
      setData(filtered);
      // verifica se existe campos selecionado
      if (props.selected) {
        var selectedFrm = [],
          selectedFld = [],
          selectedOpt = [];
        // forms
        _.at(
          _.keyBy(filtered, "title"),
          allResults
            .map((form) => ({
              form: form.name,
              fields: _.compact(
                _.at(
                  _.keyBy(form.fields, "_id"),
                  _.map(props.selected, "field")
                )
              ),
            }))
            .filter((obj) => obj.fields.length > 0)
            .map((obj) => obj.form.replace("obj_", ""))
        ).map((obj) => selectedFrm.push(obj.key));
        // campos e opcoes
        _.flattenDeep(
          filtered.map((obj) =>
            _.compact(
              _.at(_.keyBy(obj.children, "key"), _.map(props.selected, "field"))
            )
          )
        ).forEach((field) => {
          selectedFld.push(field.key);
        });
        // seleciona as opcoes
        const filteredTree = filterTree(selectedFrm, selectedFld, filtered);
        setCheckedNodes(filteredTree);
        setSelectedFields(selectedFld);

        const fieldMap = {};
        filtered.forEach(form => {
          form.children.forEach(child => {
            fieldMap[child.key] = {
              fieldName: child.field,
              form: `obj_${form.title}`
            };
          });
        });

        const enrichedSelected = props.selected.map(item => ({
          ...item,
          fieldName: fieldMap[item.field]?.fieldName || "",
          form: fieldMap[item.field]?.form || item.form
        }));

        props.form.setFieldsValue({ refOpt: enrichedSelected });
        props.onChange(enrichedSelected);
        if (props.onReady) {
          props.onReady();
        }
      }
    });
  };

  const onCheck = (fields, info) => {
    const isFormClick = !!info.node.children;
    const isFieldClick = !info.node.children;

    // Verificação para click em um nó do formulário
    const blockedMap = new Set(
      data
      .flatMap(f => f.children)
      .filter(c => c.isBlocked)
      .map(c => c.key)
    );

    if (isFormClick) {
      const childrenKeys = info.node.children.map(child => child.key);
      const hasBlocked = childrenKeys.some(id => blockedMap.has(id));
      if (hasBlocked) {
        Modal.warning({
          title: "[CAMPO DUPLICADO] - ATENÇÃO",
          content: "O campo selecionado já existe no formulário pai."
        });
        return;
      }
    }

    // Verificação para click em um nó do campo
    const clickedNode = info.node;
    const isBlocked = clickedNode.isBlocked;
    const isSelected = selectedFields.includes(clickedNode.key);
    if (isBlocked && !isSelected && isFieldClick) {
      Modal.warning({
        title: "[CAMPO DUPLICADO] - ATENÇÃO",
        content: "O campo selecionado já existe no formulário pai.",
      });
      return;
    }

    const filteredTree = filterTree(
        fields,
        info.halfCheckedKeys,
        props.selected ? (info.data ? info.data : data) : data
      ),
      nodes = filteredTree,
      result = [];
    nodes.forEach((node) => {
      node.children.forEach((child) => {
        result.push({
          form: `obj_${node.title}`,
          field: child.key,
          fieldName: child.field
        });
      });
    });
    // seleciona as opcoes
    props.form.setFieldsValue({ refOpt: result });
    props.onChange(result);
    setCheckedNodes(filteredTree);
    setSelectedFields(fields);
  };

  return (
    <div>
      <div>
        <Card>
          <Tree
            checkable
            defaultExpandAll
            checkedKeys={selectedFields}
            onCheck={onCheck}
            height={200}
            disabled={props.disabled ? true : false}
          >
            {renderTreeNodes(data)}
          </Tree>
        </Card>
      </div>
    </div>
  );
}
